const getSessionEndFromSessionLength = (start, sessionLength) => {
  return new Date(
    new Date(start).getTime() + sessionLength * 60 * 1000,
  ).toISOString();
};

export default getSessionEndFromSessionLength;
